// relative to contract data that we want to store : fields values
const telecomSubscriptionData = {
  contract: {
    providerId: '',
    offerId: '',
    providerOptions: {},
    providerExternalId: '',
  },
  characteristics: {
    productType: '',
    prestationType: '',
  },
}

export default telecomSubscriptionData
